import noUiSlider from "nouislider";
import BRecipeList from "./BRecipeList";

function initSlider(container) {
	const slider = container.querySelector(".slider-item");
	if (!slider || slider.noUiSlider) {
		return;
	}

	const min = parseFloat(slider.dataset.min);
	const max = parseFloat(slider.dataset.max);
	const step = parseFloat(slider.dataset.step) || 1;
	const unit = slider.dataset.unit || "";
	const start = parseFloat(slider.dataset.start);
	const end = parseFloat(slider.dataset.end);

	if (isNaN(min) || isNaN(max) || min >= max) {
		return;
	}

	noUiSlider.create(slider, {
		start: [isNaN(start) ? min : start, isNaN(end) ? max : end],
		connect: true,
		step: step,
		range: { min, max },
		format: {
			to(value) {
				return Math.floor(value) + " " + unit;
			},
			from(value) {
				return parseFloat(String(value).replace(" " + unit, ""));
			},
		},
	});

	const valueLower = container.querySelector(".value-lower");
	const valueUpper = container.querySelector(".value-upper");
	const hiddenMin = container.querySelector("[data-id=\"" + slider.id + "-0\"]");
	const hiddenMax = container.querySelector("[data-id=\"" + slider.id + "-1\"]");

	slider.noUiSlider.on("update", (values, handle) => {
		const raw = String(values[handle]).replace(/[^\d.\-]/g, "");

		if (handle === 0) {
			if (valueLower) valueLower.textContent = values[handle];
			if (hiddenMin) hiddenMin.value = raw;
		} else {
			if (valueUpper) valueUpper.textContent = values[handle];
			if (hiddenMax) hiddenMax.value = raw;
		}
	});

	slider.noUiSlider.on("change", () => {
		const form = container.closest("[data-list]");
		if (!form) return;

		const params = BRecipeList.getParams(form);
		if (!params.ranges) params.ranges = {};

		params.ranges[slider.id] = {
			min: hiddenMin ? hiddenMin.value : "",
			max: hiddenMax ? hiddenMax.value : "",
		};

		form.dataset.params = JSON.stringify(params);
		BRecipeList.reload(form);
	});
}

function resetAll(form) {
	form.querySelectorAll(".range-slider .slider-item").forEach((slider) => {
		if (slider.noUiSlider) {
			slider.noUiSlider.set([
				parseFloat(slider.dataset.min),
				parseFloat(slider.dataset.max),
			]);
		}
	});
}

export default {
	initialize() {
		document.querySelectorAll(".range-slider").forEach(initSlider);
	},
	resetAll,
};
